import { render, staticRenderFns } from "./QuizTable.vue?vue&type=template&id=0707d986&scoped=true&"
import script from "./QuizTable.vue?vue&type=script&lang=js&"
export * from "./QuizTable.vue?vue&type=script&lang=js&"
import style0 from "./QuizTable.vue?vue&type=style&index=0&id=0707d986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0707d986",
  null
  
)

export default component.exports